// import state from "./state";

export const activeLanguage = (state) => state.activeLanguage;
export const contactUsPage = (state) => state.contactUsPage;
export const careerPageUpdate = (state) => state.careerPage;
export const jobactiveJobUpdate = (state) => state.activeJob;
